import { useHasPermission } from '~/modules/common/permissions';

export const useCanEditAllClients = () =>
  useHasPermission({
    actionUri: 'urn:replicon:client-action:edit-client',
    dataAccessLevelUri: 'urn:replicon:client-data-access-level:all'
  });
